<div class="interactive-scoring-image-header">
    <i class="icon-chevron-left chevron mright8" (click)="carouselService.selectPrevious()" [class.chevron--disabled]="carouselService.isFirst$ | async"></i>
    <i class="icon-chevron-right chevron mright16 mleft8" (click)="carouselService.selectNext()" [class.chevron--disabled]="carouselService.isLast$ | async"></i>
    <span class="mx-textellipsis" [title]="title">{{ title }}</span>
</div>